import Container from 'react-bootstrap/Container';

const Footer = () => {
    return (
        <footer className='footer bg-dark'>
            <Container>
                <span>© VladV 2023</span>
            </Container>
        </footer>
    );
};

export default Footer;
